import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { getInputs, organizeForm } from "@vfit/shared/data-access";
import CmsForm from "../CmsForm/cmsForm";
var LeadPlatform = function(param) {
    var form = param.form, onSuccess = param.onSuccess, onError = param.onError, onTrackSubmit = param.onTrackSubmit;
    var cmsForms = organizeForm(form);
    var widgetForms = getInputs(cmsForms.input);
    return /*#__PURE__*/ _jsx(CmsForm, _object_spread_props(_object_spread({}, widgetForms), {
        config: cmsForms.config,
        submitConfig: cmsForms.submit,
        onSuccessForm: onSuccess,
        onErrorForm: onError,
        onTrackSubmit: onTrackSubmit
    }));
};
export default LeadPlatform;
